import { createAuthClient } from 'better-auth/client';
import { organizationClient, adminClient } from 'better-auth/client/plugins';

/**
 * Better Auth browser client. baseURL defaults to the current origin (+ /api/auth) — in
 * dev the Vite proxy forwards those to the API, so everything stays same-origin and the
 * httpOnly session cookie just works.
 *
 * No magic-link client: the server has no magic-link sign-in (MAP 249 spec §12).
 */
export const authClient = createAuthClient({
  plugins: [organizationClient(), adminClient()],
});
